import React from 'react';
import {
    withStyles,
    Grid,
    Typography,
    ButtonBase,
    Snackbar,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"

import MBack from '../view/MBack';
import Apis from '../../network/Apis';
import AppUtils from '../../control/apputlis';
import copy from 'copy-to-clipboard'; 
import ListView from 'antd-mobile/lib/list-view/index'; 

const ICON_SHOU = require("../../images/icons/shou_icon.png");
const ICON_ZANWU = require("../../images/bg/zanwu.png");
const ICON_HUODONG = require("../../images/icons/huodong.png");


class IntegralGoods extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            snackopened: false,
            message: '',
            page: 0,
            total: 1,
        };
    }

    componentDidMount() {
        const { page } = this.state;
        this.encryptionMyGiftOrderList(page);
        AppUtils.YMPush('MAIN', 'IntegralGoods');
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    encryptionMyGiftOrderList = async (page) => {
        let { channel, uid, token } = this.props.match.params;
        let result = await Apis.encryptionMyGiftOrderList(uid, token, channel, 10, page);
        console.log('encryptionMyGiftOrderList', result);
        if (result.code == 200) {
            let { data } = this.state;
            for (let i = 0; i < result.data.list.length; i++) {
                data.push(result.data.list[i]);
            }
            this.setState({ data: data, total: result.data.total });
        }
    }

    onClickQQ = (qq) => {
        if (copy(qq)) {
            this.setState({ snackopened: true, message: 'FID号已复制' });
        }
    }

    onClickAddress = (item) => {
        let { channel, uid, token, nav } = this.props.match.params;
        this.props.history.push({ pathname: '/integraladdress/' + channel + "/" + uid + "/" + token + "/" + item.id + '/' + item.num + "/" + nav });
    }

    _renderItem = (item, sectionID, rowID) => {
        const { classes } = this.props;
        return (
            <Grid key={rowID} container direction='column' alignItems='center' className={classes.listItem}>
                <Grid container direction='row' alignItems='center' justifyContent='space-between' style={{ marginTop: 12, flex: 1 }}  >
                    <Grid container direction='row' alignItems='center' style={{ flex: 1 }}>
                        <img src={item.gift_info.cover} style={{ width: 65, height: 70 }} />
                        <Grid style={{ flex: 1, marginLeft: 12 }}>
                            <Grid container direction='row' alignItems='center' style={{ flex: 1 }}>
                                <Typography style={{ fontSize: 14, color: "#0D0D0D" }}> {item.gift_info.name}  </Typography>
                                {
                                    item.gift_info.tag.length > 0 && <img src={ICON_HUODONG} style={{ marginLeft: 4, width: 43, height: 15 }} />
                                }
                            </Grid>
                            <Typography style={{ fontSize: 12, color: "#919191", marginTop: 4 }}>{item.gift_info.info}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container direction='column' alignItems='flex-end' style={{ width: 80 }}>
                        <Typography style={{ fontSize: 14, color: "#000000" }}>{"+" + item.score + "积分"}</Typography>
                        <Typography style={{ fontSize: 10, color: "#919191" }}>{'x' + item.num}</Typography>
                    </Grid>
                </Grid>
                {
                    item.is_add_info == 1 && <Grid container direction='row' alignItems='center' style={{ marginTop: 12, marginBottom: 8 }}>
                        <Grid style={{ backgroundColor: '#E2E2E2', width: '100%', height: 0.5 }} />
                    </Grid>
                }
                {
                    item.is_add_info == 1 && <Grid container direction='row' alignItems='flex-start' style={{ width: '100%', marginTop: 8 }}>
                        <Grid style={{ width: 24 }}>
                            <img src={ICON_SHOU} style={{ width: 24, height: 24 }} />
                        </Grid>
                        <Grid style={{ flex: 1, marginLeft: 8 }}>
                            <Typography style={{ fontSize: 14, color: "#0D0D0D" }}>{item.name + "  " + item.phone}</Typography>
                            <Typography style={{ fontSize: 10, color: "#0D0D0D" }}>{item.location + "    " + item.postal_code}</Typography>
                        </Grid>
                    </Grid>
                }
                {
                    item.is_add_info == 0 && <Grid container direction='row' alignItems='flex-start' style={{ width: '100%', height: 24 }}>
                    </Grid>
                }

                <Grid container direction='row' alignItems='center' justifyContent='flex-end' style={{ width: '100%', marginTop: 12 }}>
                    {<ButtonBase onClick={() => this.onClickQQ(item.qq)} className={classes.buttonService}>添加客服FID</ButtonBase>}
                    {item.is_add_info == 0 && <ButtonBase className={classes.buttonQQ} onClick={() => this.onClickAddress(item)} >添加地址</ButtonBase>}
                </Grid>
            </Grid>
        );
    }

    _onEndReached = () => {
        let page = this.state.page + 1;
        this.setState({ page: page }, () => {
            this.encryptionMyGiftOrderList(page);
        })
    }

    render() {
        const { classes } = this.props;
        const { data, snackopened, message, total } = this.state;

        const ds = new ListView.DataSource({
            rowHasChanged: (r1, r2) => r1 !== r2
        });

        let { nav } = this.props.match.params;

        return (
            <MBack title='我兑换的商品' backgroundColor={data.length == 0 ? "#FFF" : "#EEEEEE"} hideNav={nav}>
                <Grid className={classes.container}>
                    {
                        (data.length > 0) && <ListView
                            initialListSize={data.length}
                            listPrefixCls='padding: 0px'
                            style={{ width: '100%', height: '100vh' }}
                            contentContainerStyle={{ width: '100%', padding: 0 }}
                            dataSource={ds.cloneWithRows(data)}
                            renderRow={this._renderItem}
                            pageSize={10}
                            useBodyScroll={false}
                            onEndReached={this._onEndReached}
                            onEndReachedThreshold={10}
                        />
                    }
                    {
                        total == 0 && <Grid container direction='column' alignItems="center" justifyContent="center" style={{ marginTop: 72 }} >
                            <img src={ICON_ZANWU} style={{ width: 170, height: 170 }} />
                            <Typography style={{ fontSize: 12, color: "#919191", marginTop: 12 }}>暂无兑换的商品</Typography>
                        </Grid>
                    }
                </Grid>



                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackopened}
                    onClose={() => this.setState({ snackopened: false })}
                    message={message}
                    autoHideDuration={3000}>
                </Snackbar>
            </MBack >
        );
    }
}

export default withRouter(withStyles((theme) => ({
    container: {
        paddingBottom: 12
    },
    listItem: {
        marginTop: 20,
        borderRadius: 10,
        backgroundColor: '#FFF',
        borderRadius: 10,
        paddingBottom: 12,
        paddingRight: 12,
        paddingLeft: 12
    },
    buttonService: {
        border: 'solid 1px #E2E2E2',
        width: 100,
        height: 30,
        fontSize: 13,
        color: '#0D0D0D',
        borderRadius: 15,
        marginLeft: 8,
        marginRight: 8
    },
    buttonQQ: {
        border: 'solid 1px #F44C4C',
        width: 100,
        height: 30,
        fontSize: 13,
        color: '#F44C4C',
        borderRadius: 15,
        marginLeft: 8,
        marginRight: 8
    },
    f7activity: {
        color: '#F44C4C',
        fontSize: 8,
        border: 'solid 1px #F44C4C',
        height: 16,
        width: 42,
        borderRadius: 8,
        paddingLeft: 6,
        paddingRight: 4,
        marginLeft: 4,
        textAlign: 'center'
    }

}))(IntegralGoods));